import React, { useRef } from 'react';
import './css/index.scss';
import MyButton from '../MyButton';
import AddPhotosIcon from '../../assets/formIcons/addPhotos.svg';
import DeletePhotoIcon from '../../assets/formIcons/deletePhoto.svg';
import PhotoUrlField from '../PhotoUrlField';
import { PHOTOS_COUNT } from '../../helpers/constants';
import {
  buildCarouselPhotos,
  countCarouselPhotos,
  splitCarouselPhotos,
} from '../../helpers/photoUrls';

/**
 * Загрузка карусели файлом и/или прямой ссылкой — для массового создания.
 */
function CarouselPhotosField({
  value = [],
  onChange,
  max = PHOTOS_COUNT.carouselMax,
  disabled = false,
  hint = 'Можно добавить файлы и прямые http(s)-ссылки. Вместе не больше лимита карусели.',
}) {
  const fileInput = useRef();
  const { files, urls } = splitCarouselPhotos(value);
  const total = countCarouselPhotos(value);

  const emit = (nextFiles, nextUrls) => {
    onChange(buildCarouselPhotos({ files: nextFiles, urls: nextUrls }).slice(0, max));
  };

  const onFilesSelect = (ev) => {
    const list = Array.from(ev.target.files || []);
    ev.target.value = '';
    if (!list.length) return;

    const room = Math.max(0, max - total);
    const converted = list.slice(0, room).map((file) => ({
      id: `photo_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`,
      file,
      uri: URL.createObjectURL(file),
    }));
    emit([...converted, ...files], urls);
  };

  const onRemove = (photo) => {
    if (photo.url) {
      emit(files, urls.filter((url) => url !== photo.url));
      return;
    }
    emit(files.filter((item) => item.id !== photo.id), urls);
  };

  return (
    <div className="carousel_photos_field">
      <div className="carousel_photos_field_actions">
        <MyButton
          text="Файл"
          svgPath={AddPhotosIcon}
          onClick={() => fileInput.current?.click()}
          secondary
          disabled={disabled || total >= max}
          className="carousel_photos_field_file_button"
        />
        <p className="carousel_photos_field_count">{`${total} / ${max}`}</p>
      </div>
      <input
        ref={fileInput}
        type="file"
        multiple
        accept="image/png, image/jpeg"
        className="carousel_photos_field_file_input"
        onChange={onFilesSelect}
        disabled={disabled}
      />
      <PhotoUrlField
        showList={false}
        max={Math.max(0, max - files.length)}
        urls={urls}
        disabled={disabled}
        onChange={(nextUrls) => emit(files, nextUrls)}
      />
      {hint ? <p className="carousel_photos_field_hint">{hint}</p> : null}

      {value.length ? (
        <div className="carousel_photos_field_grid">
          {value.map((photo) => (
            <div key={photo.id || photo.url || photo.uri} className="carousel_photos_field_item">
              <img src={photo.uri || photo.url || ''} alt="" />
              {photo.url ? <span className="carousel_photos_field_badge">URL</span> : null}
              <button
                type="button"
                className="carousel_photos_field_remove"
                aria-label="Удалить"
                onClick={() => onRemove(photo)}
                disabled={disabled}
              >
                <img src={DeletePhotoIcon} alt="" />
              </button>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default CarouselPhotosField;
